import { Effect } from 'effect';

import { removeCartItem } from '@vs-shop/engine/module/cart/cartOperations';
import type { CartMutationItem } from '../../bind/cartMutationItem';
import { TenantConfig } from '../../service/tenant/TenantConfig';
import { createRemoveFromCartPayloadFromCartItem } from '../../utils/gtm/create/cart-items-update';
import { sendGtmEvent } from '../../utils/gtm/gtm';

export type RemoveProductVariantFromOrderData = {
  cartItem: CartMutationItem;
};

export default function removeProductVariantFromOrder({
  cartItem,
}: RemoveProductVariantFromOrderData) {
  return Effect.gen(function* () {
    const { currency } = yield* TenantConfig;

    yield* removeCartItem({ itemId: cartItem.id });

    yield* createRemoveFromCartPayloadFromCartItem(
      cartItem.event,
      cartItem.quantity,
      currency
    ).pipe(Effect.flatMap((event) => sendGtmEvent(event, true)));

    return;
  });
}
